<template>
  <div class="bg-gray full-height">
   <navigation-bar />
    <div class="container-fluid" style="margin-bottom:30px;">
      <div class="row" style="padding-top:20px;">
        <div class="col-sm-5 col-centered">
          <div class="white-panel" style="margin-bottom: 0px;">
            <h1>Login</h1>
            <div class="row" style="margin-top:20px;">


              <div class="col-xs-12 col-sm-12" style="text-align:center;"> 
              <v-facebook-login
                v-if="fb"
                 app-id="615742785813797" 
                 :login-options="loginOptions" 
                 :value="connected" 
                 @login="loginWithFacebook"></v-facebook-login>
              </div>
              <p
                v-if="fb" style="text-align:center; margin:auto;margin-top:20px;margin-bottom:20px">Or</p>
              <div class="col-xs-12 col-sm-12">
                <div class="form-group">
                  <input v-on:keyup.enter="login" v-model="email" class="form-control" placeholder="Email">
                </div>
                <div class="form-group">
                  <input v-on:keyup.enter="login" v-model="password" type="password" class="form-control" placeholder="Password">
                </div>
                <div class="form-group">
                  <button v-on:click="login" style="width:100%;" class="btn btn-primary btn-blue">Login</button>
                </div>
                <div class="form-group">
                  <button v-on:click="forgotPassword" style="width:100%;" class="btn btn-danger btn-orange">Forgot Password</button>
                </div>
                <a class="blue" href="/">Go Home</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
import NavigationBar from '@/components/nav/NavigationBar'
import API from '@/API/API'
import DashboardFooter from '@/components/nav/Footer'
import Utils from '@/Utils/Utils'
import Navigator from '@/router/navigator'
import AccountSessionUtils from "./AccountSessionUtils";
import VFacebookLogin from 'vue-facebook-login-component'

export default {
  name: 'Login',
  components: {
    NavigationBar,
    DashboardFooter,
    VFacebookLogin
  },
  data () {
    return {
      api: API,
      nav: Navigator,
      email: '',
      password: '',
      accountUtils: AccountSessionUtils,
      loginOptions: {
        scope: 'email,public_profile'
      },
      connected:{},
      fb: true
    }
  },
  mounted () {
    this.getSession()
    // this.showFacebook()
  },
  methods: {
    showFacebook() {
      this.fb = this.$route.params.afterRoute == 'fb'
    },
    getSession: function() {
      let self = this
      this.accountUtils.authorize(
        userId => {
          if (userId != "0") {
            self.nav.goHome(this);
          }
        },
        err => {
          // this.$toasted.show(err, { type: "error", duration: 2500 });
        }
      );
    },
    storeSession: function(sessionId) {
      localStorage.ECDsessionid = sessionId
    },
    login: function() {

      if(this.email == ''){
        this.$toasted.show('Email is required', { type: 'error', duration: 2500 })
        return
      }

      if(this.password == ''){
        this.$toasted.show('Password is required', { type: 'error', duration: 2500 })
        return
      }

      let self = this
      this.api.loginUser(this.email, this.password)
      .then(function (res) {
        let resData = res.data;
        if("error" in resData){
          let error = resData.error;
          self.$toasted.show(error, { type: 'error', duration: 2500 })
        }else{
          self.storeSession(resData.sessionId)
          if(self.$route.params.parent){
            self.nav.goFeed(self,self.$route.params.parent)
          }else if(self.$route.params.afterRoute == "CreateListing"){
            self.nav.goCreateListing(self)
          }else if(self.$route.params.afterRoute == "MyListings"){
            self.nav.goListings(self)
          }else if(self.$route.params.afterRoute == "MyAccount"){
            self.nav.myAccount(self)
          }else{
            self.nav.goHome(self)
          }
        }
      })
      .catch(e => {
        self.$toasted.show(e, { type: 'error', duration: 2500 })
      })
    },
    forgotPassword:function() {
      this.nav.forgotPassword(this)
    },
    loginWithFacebook:function (object) {

      if("authResponse" in object){
        let response = object.authResponse;
        let accessToken = response.accessToken;
        this.getFacebookUser(accessToken)
      }else{
          this.$toasted.show('Failed to log in', {
            type: 'error',
            duration: 2500
          })
      }

    },
    getFacebookUser:function(accessToken) {
      var that = this
      this.api.getFacebookUser(accessToken).then(function(res){
          if("data" in res){
            let data = res.data;
            let user = {
              facebook_id:'',
              email:'',
              first_name:'',
              last_name:''  
            }

            if("id" in data){
              user.facebook_id = data.id
            }

            if("email" in data){
              user.email = data.email
            }

            if("first_name" in data){
              user.first_name = data.first_name
            }

            if("last_name" in data){
              user.last_name = data.last_name
            }
            

            that.loginWithFaceookToServer(user)
          }
        }).catch(e => {
        })
    },
    loginWithFaceookToServer(user) {
      var self = this
      this.api.facebookLogin(
        user.first_name,
        user.last_name,
        user.email,
        user.facebook_id,
        0
      ).then(function(res){
        let resData = res.data;
        if("error" in resData){
          let error = resData.error;
          self.$toasted.show(error, { type: 'error', duration: 2500 })
        }else{
          self.storeSession(resData.sessionId)
          if(self.$route.params.parent){
            self.nav.goFeed(self,self.$route.params.parent)
          }else if(self.$route.params.afterRoute == "CreateListing"){
            self.nav.goCreateListing(self)
          }else if(self.$route.params.afterRoute == "MyListings"){
            self.nav.goListings(self)
          }else if(self.$route.params.afterRoute == "MyAccount"){
            self.nav.myAccount(self)
          }else{
            self.nav.goHome(self)
          }
        }
      }).catch(function(err){
        self.$toasted.show(e, { type: 'error', duration: 2500 })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
.v-facebook-login {
  margin:auto;
}
</style>


// WEBPACK FOOTER //
// src/components/account/Login.vue